import React, { Fragment, useContext } from 'react'
import { Card, Grid, List, ListItem, Message } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../App/stores/RootStore'
import Moment from "react-moment";

const RequestReviewDocumentNoteList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { requestReviewDocumentNotesById } = rootStore.requestReviewDocumentNoteStore;

    return (
        <Fragment>
            <Grid columns={3} divided style={{ overflowY: "auto" }}>
                {requestReviewDocumentNotesById.map(([group, requestReviewDocumentNotes]) => (
                    <Fragment key={group}>
                        {requestReviewDocumentNotes.map(requestReviewDocumentNote => (
                            <Grid.Column width={8}>
                                <Card.Group>
                                    <Card fluid>
                                        <Card.Content>
                                            <Card.Header>
                                                {requestReviewDocumentNote.noteType}
                                            </Card.Header>
                                            <Card.Meta>
                                                <List>
                                                    <ListItem>ID: {requestReviewDocumentNote.id}</ListItem>
                                                    <ListItem>Submitted By: {requestReviewDocumentNote.createdByName}</ListItem>
                                                    <ListItem>Submitted On: <Moment format={'MMM D YYYY hh:mm:ss A'} date={requestReviewDocumentNote.dateCreated} /></ListItem>
                                                </List>
                                            </Card.Meta>
                                            <Card.Description>
                                                <Message content={requestReviewDocumentNote.note} />
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>
                                </Card.Group>
                            </Grid.Column>
                        ))}
                    </Fragment>
                ))}
            </Grid>
        </Fragment>
    )
}
export default observer(RequestReviewDocumentNoteList);